import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PostCard from '../components/PostCard';
import CreatePost from '../components/CreatePost';
import './Feed.css';

function Feed() {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchPosts = async (pageNum = page) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await axios.get(`/api/posts/feed?page=${pageNum}&size=10`);
      const newPosts = response.data.content.filter(post => post.postType === 'ARTICLE');

      setPosts(prev => pageNum === 0 ? newPosts : [...prev, ...newPosts]);
      setHasMore(!response.data.last);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshFeed = () => {
    setPage(0);
    fetchPosts(0);
  };

  useEffect(() => {
    let cancelled = false;

    const loadPosts = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/api/posts/feed?page=${page}&size=10`);
        if (cancelled) return;
        const newPosts = response.data.content.filter(post => post.postType === 'ARTICLE');
        setPosts(prev => page === 0 ? newPosts : [...prev, ...newPosts]);
        setHasMore(!response.data.last);
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadPosts();
    return () => { cancelled = true; };
  }, [page]);

  const handlePostCreated = (newPost) => {
    setPosts([newPost, ...posts]);
  };

  const handlePostDeleted = (postId) => {
    setPosts(posts.filter(post => post.id !== postId));
  };

  return (
    <div className="feed-container">
      <div className="feed-content">
        <div className="feed-header">
          <h2>Public Feed</h2>
          <p className="feed-subtitle">
            Articles shared by everyone on Socify
          </p>
        </div>

        <CreatePost onPostCreated={handlePostCreated} />

        <div className="posts-list">
          {posts.length === 0 && !loading && (
            <div className="feed-empty">
              <h3>No articles yet</h3>
              <p>Be the first to share an article!</p>
            </div>
          )}
          {posts.map(post => (
            <PostCard
              key={post.id}
              post={post}
              onDelete={handlePostDeleted}
              onFollowChange={refreshFeed}
            />
          ))}
        </div>

        {hasMore && !loading && posts.length > 0 && (
          <button
            className="load-more-btn"
            onClick={() => setPage(page + 1)}
          >
            Load More
          </button>
        )}

        {loading && <div className="loading">Loading...</div>}
      </div>
    </div>
  );
}

export default Feed;
